import { InputEdit } from "components";
import { useEffect, useState } from "react";
import { Button, Col, Container, Form } from "react-bootstrap";

import { useUsersApi, useAuth } from "utils/hooks";
import { useSearchParams } from "react-router-dom";
import "./ChangePassword.css";

export function ChangePassword() {
  const api = useUsersApi();
  const { onLogout } = useAuth();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorMessages, setErrorMessage] = useState({
    newPassword: null,
    confirmPassword: null,
  });

  const [isValidated, setValidated] = useState(false);
  const [isCompleted, setCompleted] = useState(false);
  const [isFailed, setFailed] = useState(false);
  const [searchParams] = useSearchParams();

  const [recoverToken, setRecoverToken] = useState(null);

  const verifyRecoverToken = async (token) => {
    try {
      const response = await api.verifyRecoverToken(token);
      if (response.status !== "SUCCESS") setFailed(true);
      return response;
    } catch (e) {
      setFailed(true);
    }
  };

  const changePassword = async (newPassword) => {
    try {
      const response = await api.changePassword(newPassword, recoverToken);
      if (response.status !== "SUCCESS") setFailed(true);
      else setCompleted(true);

      return response;
    } catch (e) {
      setFailed(true);
    }
  };

  function changePasswordForm() {
    return (
      <>
        <Form.Group style={{ opacity: 1 }}>
          <InputEdit
            placeholder={"Enter password"}
            label={"New password"}
            type={"password"}
            error={errorMessages.newPassword}
            onFocus={() =>
              setErrorMessage({ ...errorMessages, newPassword: null })
            }
            onBlur={(e) => {
              if (e.target.value.trim() === "") {
                setErrorMessage({
                  ...errorMessages,
                  newPassword: "cannot be empty",
                });
                return;
              }

              if (newPassword !== confirmPassword) {
                setErrorMessage({
                  ...errorMessages,
                  confirmPassword: "Password do not match",
                });
              } else
                setErrorMessage({
                  ...errorMessages,
                  confirmPassword: null,
                  newPassword: null,
                });
            }}
            onChange={(e) => {
              setErrorMessage({ ...errorMessages, newPassword: null });
              setNewPassword(e.target.value);
            }}
          />
        </Form.Group>

        <Form.Group style={{ opacity: 1 }}>
          <InputEdit
            placeholder={"Enter password"}
            label={"Confirm password"}
            type={"password"}
            error={errorMessages.confirmPassword}
            onFocus={(e) => {
              setErrorMessage({
                ...errorMessages,
                confirmPassword: null,
              });
            }}
            onBlur={(e) => {
              if (newPassword !== confirmPassword) {
                setErrorMessage({
                  ...errorMessages,
                  confirmPassword: "Password do not match",
                });
              } else
                setErrorMessage({
                  ...errorMessages,
                  confirmPassword: null,
                  newPassword: null,
                });
            }}
            onChange={(e) => {
              setErrorMessage({
                ...errorMessages,
                confirmPassword: null,
              });
              setConfirmPassword(e.target.value);
            }}
          />
        </Form.Group>
        <Form.Group className="mt-4 ms-2 me-2 text-center">
          <Button
            type="submit"
            lg={8}
            className="btn btn-primary mt-3"
            disabled={!isValidated}
            onClick={async (e) => {
              e.preventDefault();

              const result = await changePassword(newPassword, recoverToken);
              if (!result) {
                setError("Account doesn't exists");
                return;
              }
            }}
          >
            Reset password
          </Button>
        </Form.Group>
      </>
    );
  }

  function ErrorMessage({ message }) {
    return message ? (
      <Form.Group className="m-3">
        <h4 className="text-danger text-center">{message}</h4>
        <p className="text-center">
          <a href="/login" className="text-primary">
            Go to Login Page
          </a>
        </p>
      </Form.Group>
    ) : null;
  }

  function SuccessMessage({ message }) {
    return message ? (
      <Form.Group className="m-3">
        <h5 className="text-success text-center">{message}</h5>
        <p className="text-center">
          <a href="/login" className="text-primary">
            Go to Login Page
          </a>
        </p>
      </Form.Group>
    ) : null;
  }

  useEffect(() => {
    if (
      confirmPassword.trim() !== "" &&
      newPassword.trim() !== "" &&
      confirmPassword === newPassword
    )
      setValidated(true);
    else setValidated(false);
  }, [confirmPassword, newPassword]);

  useEffect(() => {
    const requiredToken = searchParams.get("token");

    if (verifyRecoverToken(requiredToken)) {
      setRecoverToken(requiredToken);
      onLogout();
    } else setFailed(true);
  }, []);

  return (
    <div className="classy-subtle-dark-gray-gradient">
      <Container>
        <Container className="d-flex align-items-center justify-content-center vh-100 login-container login-component-fadein">
          <Col md={4}>
            <Form className="shadow  login-form" style={{ opacity: 0.9 }}>
              <Form.Group className="text-center">
                <img
                  src="/logo/logo.png"
                  width={200}
                  className="rounded img-responsive"
                  alt="ECHO Platform"
                />
              </Form.Group>

              {!isCompleted && !isFailed && changePasswordForm()}
              {isFailed && (
                <ErrorMessage message={"Invalid or expired recovery request"} />
              )}
              {isCompleted && (
                <SuccessMessage
                  message={`Your password has been changed successfully`}
                />
              )}
            </Form>
          </Col>
        </Container>
      </Container>
    </div>
  );
}
